// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"690":"e2bbfe72","707":"47dc5ceb"}[chunkId] + ".chunk.js";
};